import type ClassificationViewState from 'owa-mail-protection-types/lib/schema/classification/ClassificationViewState';
import setMessageClassification from '../../actions/classification/setMessageClassification';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import { MESSAGE_CLASSIFICATION_INFOBAR_MESSAGE_ID } from './constants';
import type { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function clearClassification(
    viewState: ClassificationViewState,
    infobarViewState: InfoBarHostViewState
) {
    if (!viewState) {
        return;
    }
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (17,41): Argument of type 'null' is not assignable to parameter of type 'MessageClassificationType'.
    // @ts-expect-error
    setMessageClassification(viewState, null);
    removeInfoBarMessage(infobarViewState, MESSAGE_CLASSIFICATION_INFOBAR_MESSAGE_ID);
}
